import { LOCALE } from 'constants/index';

export const formatPrice = price => {
    price = parseInt(price, 10);
    return `${LOCALE.currencySymbol}${price.toFixed(2)}`;
};



// WEBPACK FOOTER //
// ./src/utils/formPriceHtml.js